import { Table, Box } from "@chakra-ui/react";

const exampleResults = [
  {
    id: 1,
    fileName: "example1.pdf",
    jobId: "job-001",
    status: "Completed",
    createdAt: "2024-06-01 10:00",
    completedAt: "2024-06-01 10:10",
  },
  {
    id: 2,
    fileName: "example2.docx",
    jobId: "job-002",
    status: "Processing",
    createdAt: "2024-06-02 11:00",
    completedAt: "-",
  },
];

const ExtractionResults = () => {
  return (
    <Box>
      <Table.Root mb={8}>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader>ID</Table.ColumnHeader>
            <Table.ColumnHeader>File Name</Table.ColumnHeader>
            <Table.ColumnHeader>Job ID</Table.ColumnHeader>
            <Table.ColumnHeader>Status</Table.ColumnHeader>
            <Table.ColumnHeader>Created At</Table.ColumnHeader>
            <Table.ColumnHeader>Completed At</Table.ColumnHeader>
            <Table.ColumnHeader>Actions</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {exampleResults.length === 0 ? (
            <Table.Row>
              <Table.Cell colSpan={7} style={{ textAlign: "center" }}>
                No results.
              </Table.Cell>
            </Table.Row>
          ) : (
            exampleResults.map((row) => (
              <Table.Row key={row.id}>
                <Table.Cell>{row.id}</Table.Cell>
                <Table.Cell>{row.fileName}</Table.Cell>
                <Table.Cell>{row.jobId}</Table.Cell>
                <Table.Cell>{row.status}</Table.Cell>
                <Table.Cell>{row.createdAt}</Table.Cell>
                <Table.Cell>{row.completedAt}</Table.Cell>
                <Table.Cell>{/* 액션 버튼 자리 */}</Table.Cell>
              </Table.Row>
            ))
          )}
        </Table.Body>
      </Table.Root>
    </Box>
  );
};

export default ExtractionResults;
